import { SetState } from 'zustand';
import { UseThemeStore } from './index';

export function setMode(set: SetState<UseThemeStore>): UseThemeStore['setMode'] {
  return async function (mode: 'light' | 'dark') {
    set({ mode });
  };
}
